export default "__VITE_ASSET__10ec540b__"